import '../utils/link-more';
import scrollViewport from '../utils/scroll-viewport';


scrollViewport('.screen', function($screen) {
    $screen.addClass('active').removeClass('disabled-animated');
}, {
    delayDistance:200,
    onLeave: function($screen) {
        $screen.removeClass('active');
    }
});
$('.mlist').linkMore({num:6});



// WEBPACK FOOTER //
// ./src/js/case.js